const OptimisticObjFactory = (profile, referenceId, commentValue) => {
  return {
    __typename: 'CommentType',
    id: referenceId,
    body: commentValue,
    contentId: crypto.randomUUID(),
    createdAt: new Date().toJSON(), // '2020-07-15T11:45:14+00:00',
    subCommentCount: '0',
    subComments: [],
    moderated: false,
    user: {
      username: profile.nickname,
      avatarUrl: profile.profilePicture
        ? `${profile.profilePicture}?d=240x240`
        : '',
      __typename: 'User',
    },
    isOptimistic: true,
    activeUser: {
      opinionPositive: false,
    },
    opinionPositiveCount: '0',
    removed: false,
    status: 2,
  };
};

export default OptimisticObjFactory;
